import config from '@/utils/Config'
import {get, post } from '@/utils/request'

export function getMilestoneList(params = {}) {
    return get(config.BASE_URL, config.getMilestoneList, params)
}

export function getAdminMilestoneList(params = {}) {
    return post(config.BASE_URL, config.getAdminMilestoneList, params)
}

export function saveMilestoneInfo(MilestoneInfo) {
    return post(config.BASE_URL, config.saveMilestoneInfo, MilestoneInfo)
}

export function delMilestone(params = { id: id }) {
    return post(config.BASE_URL, config.delMilestoneUrl, params)
}